import defineComponent from 'flight';
import memberInfo from 'static/script/app/data/member-info';
import WithAjax from 'static/script/app/data/with-ajax';

function SavedSearchesService() {

    this._removeItemFromSavedSearches = function (evt, payload) {
        this._whenLoggedIn(function () {
            let successCallback = function () {
                this.trigger(document, 'data:saved-searches:after-removed', payload);
            }.bind(this);

            this._post({
                url: '/my/savedsearches/remove',
                data: payload,
                success: successCallback
            });

        }.bind(this));
    };

    this._addSavedSearch = function (evt, payload) {
        this._whenLoggedIn(function () {
            this._post({
                url: '/my/savedsearches/add',
                data: payload.data,
                success: 'data:saved-searches:after-added'
            });
        }.bind(this));
    };

    this._monitoringSearchCallback = function (eventName, searchId, sendMail, element) {
        this.trigger(eventName, {searchId: searchId, sendMail: sendMail, element: element});
    };

    this._startMonitoringSearch = function (evt, payload) {
        this._whenLoggedIn(function () {
            this._post({
                url: '/my/savedsearches/notification',
                data: payload,
                success: function () {
                    this._monitoringSearchCallback('data:saved-searches:after-monitor-start', payload.SearchId, payload.SendMail, payload.element);
                }.bind(this)
            });
        }.bind(this));
    };

    this._stopMonitoringSearch = function (evt, payload) {
        this._whenLoggedIn(function () {
            this._post({
                url: '/my/savedsearches/notification',
                data: payload,
                success: function () {
                    this._monitoringSearchCallback('data:saved-searches:after-monitor-stop', payload.SearchId, payload.SendMail, payload.element);
                }.bind(this)
            });
        }.bind(this));
    };

    this._whenLoggedIn = function (callback) {
        if (!memberInfo.isLoggedIn) {
            this.trigger(document, 'ui:login:show');
            return;
        }
        callback();
    };

    this.after('initialize', function () {
        this.on(document, 'ui:saved-searches:on-remove', this._removeItemFromSavedSearches);
        this.on(document, 'ui:saved-searches:on-adding', this._addSavedSearch);

        this.on(document, 'ui:saved-searches:on-monitor-start', this._startMonitoringSearch);
        this.on(document, 'ui:saved-searches:on-monitor-stop', this._stopMonitoringSearch);
    });
}

export default defineComponent.component(SavedSearchesService, WithAjax);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/saved-searches-service.js